import React, { useState } from 'react';

import classNames from 'classnames';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CMASummaryContractsFilterDropdown from './CMASummaryContractsFilterDropdown';
import CMASummaryContractsFilterLabel from './CMASummaryContractsFilterLabel';
import { CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_OPTIONS } from '../../constants';
import { CMASummaryFilters } from '../../types';
import CMASummarySelect from '../CMASummarySelect';

const CMASummaryContractsFilter = () => {
  const [open, setOpen] = useState(false);
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;

  return (
    <CMASummarySelect
      open={open}
      onDropdownVisibleChange={(visible) => setOpen(visible)}
      value={filters?.roomComparisonType}
      className={classNames({
        active: filters?.roomComparisonType === CMA_SUMMARY_ROOM_COMPARISON_TYPE_FILTER_OPTIONS.ADVANCED_COMPARISON,
      })}
      dropdownRender={() => <CMASummaryContractsFilterDropdown open={open} onClose={() => setOpen(false)} />}
      dropdownStyle={{
        padding: 0,
        borderRadius: 0,
        border: '1px solid var(--line-gray)',
        minWidth: 420,
      }}
      labelRender={() => <CMASummaryContractsFilterLabel />}
    />
  );
};

export default CMASummaryContractsFilter;
